import jsonp from 'jsonp';
import getVideoFeedUrl from 'helpers/feeds/videoHelpers';
import { updateAdCounter } from 'helpers/ads/utils';
import * as cookie from '../../utils/cookies';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import makeRequest from '../../utils/makeRequest';
import { userVideoDataJson } from '../../utils/common';

const reducerName = 'videos';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const CLEAR_DATA = createActionName('CLEAR_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const GET_HISTORY_DATA = createActionName('GET_HISTORY_DATA');
export const HANDLE_WATCHLATER = createActionName('HANDLE_WATCHLATER');
export const ADD_TO_WATCHLATER = createActionName('ADD_TO_WATCHLATER');
export const REMOVE_FROM_WATCHLATER = createActionName(
  'REMOVE_FROM_WATCHLATER',
);
export const RECEIVE_VIDEOLIST_DATA = createActionName(
  'RECEIVE_VIDEOLIST_DATA',
);
export const RECEIVE_LINKLISTS_DATA = createActionName(
  'RECEIVE_LINKLISTS_DATA',
);
export const LOGOUT_MSG = createActionName('LOGOUT_MSG');
export const NO_HISTORY_MSG = createActionName('NO_HISTORY_MSG');
export const NO_WATCHLATER_MSG = createActionName('NO_WATCHLATER_MSG');
export const RECEIVE_VIDEOSHOW_DATA = createActionName(
  'RECEIVE_VIDEOSHOW_DATA',
);
export const HANDLE_VIDEOSHOW_DATA_ERROR = createActionName(
  'HANDLE_VIDEOSHOW_DATA_ERROR',
);

// action creators
export function getPathUrl(params) {
  let url = getVideoFeedUrl({
    path: '/videos',
    isNewVideoPath: params.isNewVideoPath,
  });
  if (params['0']) {
    const path = params['0'].split('/');
    if (parseInt(path[path.length - 1], 10) > 1) {
      const pageNo = path.pop();
      url = getVideoFeedUrl({
        path: `/videos/${path.join('/')}`,
        curpg: pageNo,
        isNewVideoPath: params.isNewVideoPath,
      });
      // url += `/${path.join('/')}&curpg=${pageNo}`;
    } else if (parseInt(params[1], 10) > 1) {
      const pageNo = params[1];
      url = getVideoFeedUrl({
        path: `/videos/${path.join('/')}`,
        curpg: pageNo,
        isNewVideoPath: params.isNewVideoPath,
      });
      // url += `/${path.join('/')}&curpg=${pageNo}`;
    } else {
      url = getVideoFeedUrl({
        path: `/videos/${path.join('/')}`,
        isNewVideoPath: params.isNewVideoPath,
      });
      // url += `/${path.join('/')}`;
    }
    /*
    const pageNo = path.slice(-1);
    // #todo, find a better way to check number , maybe using isFinite()
    if (parseInt(pageNo, 10) > 1) {
      path = path.slice(0, -2);
      //pageNo = path[path.length - 1];
      url += `/${path}&curpg=${pageNo}`;
    } else {
      if (pageNo === '/') {
        path = path.slice(0, -1);
      }
      url += `/${path}`;
    }
    */
  }
  // if (isMobile) {
  //   url += '&ismobile=true';
  // }
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  return url + primeParam;
}
function callVideosApi(params, isMobile) {
  return makeRequest.get(getPathUrl(params, isMobile), { isMobile });
}

function getVideoListData(params, isWapView) {
  let pageUrl = '/videos';
  if (params[0]) {
    pageUrl += `/${params[0]}`;
  }
  if (params[1]) {
    pageUrl += `/${params[1]}`;
  }
  const url = `/feeds/feed_videolist/feedtype-sjson.cms?path=${pageUrl}`;
  return makeRequest.get(url, { isMobile: isWapView });
}

function callLinkListsApi(isWapView) {
  const url = '/feed_more_toi/msid-61485363,feedtype-sjson.cms';
  return makeRequest.get(url, { isMobile: isWapView });
}

function callVideoShowApi(msid) {
  const url = `https://timesofindia.indiatimes.com/feed_articlelist_demo.cms?msid=${msid}&feedtype=sjson`;
  return makeRequest.get(url);
}

function noWatchLaterMsg(title, suffix) {
  return {
    type: NO_WATCHLATER_MSG,
    payload: { title, suffix },
  };
}

function logoutMsg(title, suffix) {
  return {
    type: LOGOUT_MSG,
    payload: { title, suffix },
  };
}

function handleWatchLaterData(params, data, views) {
  const watchLaterObj = {};
  const watchLater = {};
  if (data && data.length) {
    const len = data.length;
    let counter = 0;
    for (; counter < len; counter += 1) {
      if (data[counter].msid) {
        watchLaterObj[data[counter].msid] = data[counter];
      }
    }
  }

  const viewsData =
    views &&
    views.data &&
    views.data.v_views_ajax &&
    views.data.v_views_ajax.veiwcount;

  watchLater.obj = watchLaterObj;
  watchLater.arr = data;
  watchLater.params = params;
  watchLater.views = viewsData;
  return {
    type: HANDLE_WATCHLATER,
    payload: watchLater,
  };
}

function handleAddToWatchLaterData(msid) {
  return {
    type: ADD_TO_WATCHLATER,
    payload: msid,
  };
}

function handleRemoveFromWatchLaterData(msid) {
  return {
    type: REMOVE_FROM_WATCHLATER,
    payload: msid,
  };
}

function fetchWatchLaterData(params, noOfItems, dispatch, isWapView) {
  const url = `https://myt.indiatimes.com/mytimes/myActivity?activityType=WishList&openNetworkId=sso&appKey=TOI&contID=ln_myActivity&size=${noOfItems}&lastSeenId=0&after=true`;
  const ssoid = cookie.getCookie('ssoid');
  if (ssoid) {
    jsonp(url, null, (err, data) => {
      if (data && data.length) {
        const msids = [];
        data.forEach(item => {
          msids.push(item.msid);
        });
        makeRequest
          .get(`/json/v_views_ajax.cms?msids=${msids.join('%2C')}`, {
            isMobile: isWapView,
          })
          .then(views => dispatch(handleWatchLaterData(params, data, views)));
        //dispatch(handleWatchLaterData(params, data));
      } else if (params[0] === 'watch-later') {
        dispatch(noWatchLaterMsg('Watch', 'Later'));
      }
    });
  } else if (params[0] === 'watch-later') {
    dispatch(logoutMsg('Watch', 'Later'));
  }
}

function addToWatchLaterCall(msid, dispatch) {
  const url = `https://myt.indiatimes.com/mytimes/addActivity?appKey=TOI&baseEntityType=VIDEO&objectType=B&activityType=WishList&uniqueAppID=${msid}`;
  const ssoid = cookie.getCookie('ssoid');
  if (ssoid) {
    jsonp(url, null, (err, data) => {
      if (!err) {
        dispatch(handleAddToWatchLaterData(msid, data));
      }
    });
  }
}

function removeFromWatchLaterCall(msid, activityId, dispatch) {
  const url = `https://myt.indiatimes.com/mytimes/removeActivity?appKey=TOI&baseEntityType=VIDEO&objectType=B&activityType=WishList&uniqueAppID=${msid}&activityId=${activityId}`;
  const ssoid = cookie.getCookie('ssoid');
  if (ssoid) {
    jsonp(url, null, (err, data) => {
      if (!err) {
        dispatch(handleRemoveFromWatchLaterData(msid, data));
      }
    });
  }
}

function receiveVideosdata(data, params) {
  return {
    type: RECEIVE_DATA,
    payload: {
      ...data,
      url: getPathUrl(params).replace('http://', 'https://'),
    },
  };
}

function receiveVideoShowdata(data) {
  return {
    type: RECEIVE_VIDEOSHOW_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveVideoListData(data = {}) {
  if (data.seoData && data.seoData.title && typeof window === 'object') {
    document.title = data.seoData.title;
  }
  return {
    type: RECEIVE_VIDEOLIST_DATA,
    payload: data,
  };
}

function receiveLinkListsData(data) {
  return {
    type: RECEIVE_LINKLISTS_DATA,
    payload: data,
  };
}

export function clearVideosData() {
  return {
    type: CLEAR_DATA,
  };
}

function handleVideosDataError() {
  return {
    type: HANDLE_DATA_ERROR,
  };
}

function handleVideoShowDataError() {
  return {
    type: HANDLE_VIDEOSHOW_DATA_ERROR,
  };
}

function receiveHistorydata(data, views) {
  const viewsData =
    views &&
    views.data &&
    views.data.v_views_ajax &&
    views.data.v_views_ajax.veiwcount;
  return {
    type: GET_HISTORY_DATA,
    payload: { data, views: viewsData },
  };
}

function noHistoryMsg(title, suffix) {
  return {
    type: NO_HISTORY_MSG,
    payload: { title, suffix },
  };
}

export function getWatchLaterData(params, noOfItems) {
  return (dispatch, getState) => {
    const appState = getState();
    const isWapView = appState.isMobile;
    return fetchWatchLaterData(params, noOfItems, dispatch, isWapView);
  };
}

export function addToWatchLater(msid) {
  return dispatch => addToWatchLaterCall(msid, dispatch);
}

export function removeFromWatchLater(msid, activityId) {
  return dispatch => removeFromWatchLaterCall(msid, activityId, dispatch);
}

function callHistoryApi(dispatch, isWapView) {
  /*
  const url = 'http://localhost:3000/dummy/gethistory.json';
  return makeRequest.get(url);
  */
  const url = `https://myt.indiatimes.com/mytimes/myActivity?activityType=Watched&openNetworkId=sso&appKey=TOI&contID=ln_myActivity&size=5&lastSeenId=0&after=true`;
  const ssoid = cookie.getCookie('ssoid');
  if (ssoid) {
    jsonp(url, null, (err, data) => {
      if (data && data.length) {
        const msids = [];
        data.forEach(item => {
          msids.push(item.msid);
        });
        makeRequest
          .get(`/json/v_views_ajax.cms?msids=${msids.join('%2C')}`, {
            isMobile: isWapView,
          })
          .then(views => dispatch(receiveHistorydata(data, views)));
        //dispatch(receiveHistorydata(data));
      } else {
        dispatch(noHistoryMsg('History'));
      }
    });
  } else {
    dispatch(logoutMsg('History'));
  }
}

export function loadHistoryData() {
  return (dispatch, getState) => {
    const appState = getState();
    const isWapView = appState.isMobile;
    return callHistoryApi(dispatch, isWapView);
  };
}

export function loadVideosData(params, isMobile) {
  return dispatch =>
    callVideosApi(params, isMobile)
      .then(data => {
        updateAdCounter(data.data, isMobile);
        dispatch(receiveVideosdata(data.data, params));
      })
      .catch(error => dispatch(handleVideosDataError(error)));
}

export function loadVideoListData(params, isWapView) {
  return dispatch =>
    getVideoListData(params, isWapView)
      .then(response => dispatch(receiveVideoListData(response.data)))
      .catch(error => dispatch(handleVideosDataError(error)));
}

export function loadLinkListsData(isWapView) {
  return dispatch =>
    callLinkListsApi(isWapView).then(data =>
      dispatch(receiveLinkListsData(data.data)),
    );
}

export function loadVideoShowData(params) {
  return dispatch =>
    callVideoShowApi(params.msid)
      .then(data => dispatch(receiveVideoShowdata(data.data, params)))
      .catch(error => dispatch(handleVideoShowDataError(error)));
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CLEAR_DATA: {
      return {
        ...state,
        data: null,
        linkslistData: null,
        logoutError: null,
        historyError: null,
        watchLaterError: null,
      };
    }
    case GET_HISTORY_DATA: {
      const historyData = userVideoDataJson(action.payload);
      historyData.tn = 'videolist';
      historyData.name = 'history';
      historyData.suffix = '';
      if (historyData.data.items.length < 10) {
        historyData.showPagination = false;
      } else {
        historyData.showPagination = true;
      }
      return {
        ...state,
        data: historyData,
      };
    }

    case HANDLE_WATCHLATER: {
      const { payload } = action;
      const returnObj = {
        ...state,
        watchLater: payload.obj,
        watchLaterArr: payload.arr,
      };
      if (payload.params && payload.params[0] === 'watch-later') {
        let watchLaterData = userVideoDataJson({
          data: payload.arr,
          views: payload.views,
        });
        watchLaterData = {
          ...watchLaterData,
          tn: 'videolist',
          name: 'watch',
          suffix: 'later',
        };
        if (watchLaterData.data.items.length < 10) {
          watchLaterData.showPagination = false;
        } else {
          watchLaterData.showPagination = true;
        }
        returnObj.data = watchLaterData;
      }
      return returnObj;
    }
    case ADD_TO_WATCHLATER: {
      const watchLater = { ...state.watchLater };
      watchLater[action.payload] = { msid: action.payload };
      return {
        ...state,
        watchLater,
      };
    }

    case REMOVE_FROM_WATCHLATER: {
      const watchLater = { ...state.watchLater };
      if (watchLater[action.payload]) {
        delete watchLater[action.payload];
      }
      return {
        ...state,
        watchLater,
      };
    }
    case RECEIVE_VIDEOLIST_DATA: {
      return {
        ...state,
        videoListData: action.payload,
      };
    }

    case RECEIVE_LINKLISTS_DATA: {
      return {
        ...state,
        linkslistData: action.payload,
      };
    }

    case LOGOUT_MSG: {
      return {
        ...state,
        logoutError: {
          title: action.payload.title,
          suffix: action.payload.suffix,
        },
      };
    }

    case NO_HISTORY_MSG: {
      return {
        ...state,
        historyError: {
          title: action.payload.title,
          suffix: action.payload.suffix,
        },
      };
    }

    case NO_WATCHLATER_MSG: {
      return {
        ...state,
        watchLaterError: {
          title: action.payload.title,
          suffix: action.payload.suffix,
        },
      };
    }

    case RECEIVE_VIDEOSHOW_DATA: {
      return {
        ...state,
        videoShowData: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
